/**
 * El aviso de que una escritura **no se ha guardado** (#164).
 *
 * Las pantallas de control de cifras llamaban al backend con un `.then` y sin `.catch`: cuando el
 * guardado fallaba, el rechazo se quedaba sin tratar, no salía el aviso verde pero tampoco ninguno
 * rojo, y el usuario veía el valor nuevo en el popup y el viejo al recargar. En una pantalla de
 * cifras, un fallo silencioso es peor que el fallo: se estuvieron cambiando objetivos creyendo que
 * quedaban guardados.
 *
 * Va en un diálogo y no en un toast a propósito: el toast se va solo y se puede perder de vista, y
 * aquí hay que enterarse. Y el texto empieza por lo que importa —qué no se ha guardado— porque es
 * lo que el usuario necesita para decidir si lo vuelve a intentar.
 *
 *   avisoNoGuardado(self.$f7, 'el objetivo de ' + persona.codigoPersonal, err);
 *
 * El `que` es un complemento directo, en minúscula y sin punto: se escribe detrás de «No se ha
 * guardado ».
 */

const GENERICO = 'Vuelve a intentarlo y, si sigue fallando, avisa a soporte.';

/**
 * Qué decirle al usuario del error que ha devuelto el servidor.
 *
 * Los mensajes del backend no siempre son frases: `ModelNotFoundException` llega con el
 * identificador de lo que no se ha encontrado por mensaje —`message: 'BALC'`, el código de la
 * persona— y soltar «BALC» a secas no explica nada. Cuando el mensaje es una sola palabra se
 * enmarca junto al código del error en vez de darlo como explicación.
 */
function detalle(err) {
  if (!err) return GENERICO;
  if (typeof err === 'string') return err;
  let msg = typeof err.message === 'string' ? err.message.trim() : '';
  if (!msg && typeof err.error === 'string') msg = err.error.trim();
  if (!msg) return GENERICO;
  if (msg.indexOf(' ') === -1) {
    return 'El servidor ha respondido ' + (err.code || 'un error') + ' («' + msg + '»). ' + GENERICO;
  }
  return msg;
}

export default function avisoNoGuardado(f7, que, err) {
  if (!f7 || !f7.dialog) return;
  f7.dialog.alert('No se ha guardado ' + que + '.\n\n' + detalle(err), 'No se ha guardado');
}
